import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hasCustomEmailCard", "subject", "message", "defaultEmailTemplate", "canCustomiseData", "onResetField"];
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import config from 'utils/config';
import FormField from 'components/FormField';
import Stack from 'components/Stack';
import CheckboxOption from 'components/CheckboxOption';
import Hint from 'components/Hint';
import TextLink from 'components/TextLink';
import CustomEmailCard from './CustomEmailCard';
import useUserLocale from 'hooks/useUserLocale';
function CustomEmailField(_ref) {
  var hasCustomEmailCard = _ref.hasCustomEmailCard,
    subject = _ref.subject,
    message = _ref.message,
    defaultEmailTemplate = _ref.defaultEmailTemplate,
    canCustomiseData = _ref.canCustomiseData,
    onResetField = _ref.onResetField,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useUserLocale = useUserLocale(),
    locale = _useUserLocale.locale;
  var userLanguageEnabled = config.userLanguageEnabled;
  var hasPreviousCustomData = !!hasCustomEmailCard.value;
  function onToggleCustomEmailCard() {
    onResetField('subject');
    onResetField('message');
    hasCustomEmailCard.set(!hasCustomEmailCard.value);
  }
  return /*#__PURE__*/React.createElement(FormField, _extends({
    required: true,
    label: t('property_email'),
    as: "fieldset"
  }, otherProps), /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(CheckboxOption, {
    label: t('actions_customise_subject_and_message'),
    checked: hasCustomEmailCard.value,
    onChange: onToggleCustomEmailCard,
    disabled: !canCustomiseData
  }), hasCustomEmailCard.value && canCustomiseData && /*#__PURE__*/React.createElement(CustomEmailCard, {
    subject: subject,
    message: message,
    defaultEmailTemplate: defaultEmailTemplate,
    onResetField: onResetField
  }), /*#__PURE__*/React.createElement(Hint, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "content_status_share_panel_hint_email_template",
    emailTemplate: "resetRecommendation"
  }, "This notification uses the", /*#__PURE__*/React.createElement(TextLink, {
    as: NavLink,
    to: "/settings/email-templates/resetRecommendation?template-language=".concat(locale),
    target: "_blank"
  }, t('email_template_reset_recommendation_title')), "email template."), ' ', !canCustomiseData && hasPreviousCustomData && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t('nudge_hint_custom_email_data')), ' ', userLanguageEnabled && /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "nudge_hint_update_custom_email_data"
  }, "To update the customised subject and message, please", /*#__PURE__*/React.createElement(TextLink, {
    href: "#nudge_language_field"
  }, "select a language"), "for this nudge.")), !canCustomiseData && !hasPreviousCustomData && userLanguageEnabled && /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "nudge_share_panel_hint_select_language"
  }, "To customise subject and message, please", /*#__PURE__*/React.createElement(TextLink, {
    href: "#nudge_language_field"
  }, "select a language"), "for this nudge."))));
}
export default CustomEmailField;